import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
// import { AutoTranslate } from "@/components/AutoTranslate";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import DashboardLayout from "@/components/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import MenuBuilder from "@/pages/dashboard/MenuBuilder";
import QRCodePage from "@/pages/dashboard/QRCodePage";
import Settings from "@/pages/dashboard/Settings";
import Billing from "@/pages/dashboard/Billing";
import Account from "@/pages/dashboard/Account";
import Orders from "@/pages/dashboard/Orders";
import Waitlist from "@/pages/dashboard/Waitlist";
import Tables from "@/pages/dashboard/Tables";
import StaffOrders from "@/pages/dashboard/StaffOrders";
import Calendar from "@/pages/dashboard/Calendar";
import ReservationManage from "@/pages/ReservationManage";
import DailyMenu from "@/pages/dashboard/DailyMenu";
import FoodTruck from "@/pages/dashboard/FoodTruck";
import AdminPanel from "@/pages/AdminPanel";
import PublicMenu from "@/pages/PublicMenu";
import Services from "@/pages/Services";
import PaymentResult from "@/pages/PaymentResult";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-[#5aa469] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/m/:slug" element={<PublicMenu />} />
      <Route path="/menu/:slug" element={<PublicMenu />} />
      <Route path="/prenotazione/:token" element={<ReservationManage />} />
      <Route path="/servizi" element={<Services />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/termini" element={<Terms />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route path="/admin" element={<Protected adminOnly><AdminPanel /></Protected>} />
      <Route path="/dashboard" element={<Protected><DashboardLayout /></Protected>}>
        <Route index element={<Overview />} />
        <Route path="menu" element={<MenuBuilder />} />
        <Route path="orders" element={<Orders />} />
        <Route path="waitlist" element={<Waitlist />} />
        <Route path="tables" element={<Tables />} />
        <Route path="comande" element={<StaffOrders />} />
        <Route path="calendario" element={<Calendar />} />
        <Route path="daily" element={<DailyMenu />} />
        <Route path="foodtruck" element={<FoodTruck />} />
        <Route path="qr" element={<QRCodePage />} />
        <Route path="settings" element={<Settings />} />
        <Route path="billing" element={<Billing />} />
        <Route path="account" element={<Account />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/:slug" element={<PublicMenu />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          {/* <AutoTranslate /> — disattivato: app solo in italiano */}
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
